/*@flow*/
import gql from 'graphql-tag';

import type { DocumentNode } from 'graphql';
export default (gql(`
  query getDataPanelTagLoader($companyId: ID!) {
    company(id: $companyId) {
      id
      dataPanelTags
    }
  }
`): DocumentNode);
